export default {"src":"/_next/static/media/linkedin-icon.feab1517.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};